import { name, version } from '../package.json';

export default {
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
        },
        docs: {
            validation: 'One of: `small`, `medium`, `large`, `touch`.',
            description:
                'Sets the spacing applied to elements within the form. This size should always match the size of the components within.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
